<template>
  <div>
    <section class="content">
     <!-- MODAL CREAR USUARIO NUEVO -->
    <el-dialog title="Generar OC" :visible.sync="showModal" width="90%" :lock-scroll="false" max-width="500px">
        <div class="col-sm-12 entrada">
              <div class="col-sm-3">
                  <label>Razón Social</label>
              </div>
              <div class="col-sm-9">
                  <el-input type="text" v-validate="'required'" name="Razon Social" required placeholder="Razón Social" v-model="totalBuyOrders"></el-input>
              </div>
          </div>
          <div class="col-sm-12 entrada">
              <div class="col-sm-3">
                  <label>Fecha de liberacion</label>
              </div>
              <div class="col-sm-2">
                  <el-date-picker
              v-model="fecha"
              type="date">
              </el-date-picker>
              </div>
          </div>
          <div class="col-sm-12 entrada">
            <div class="col-sm-3">
                <label>OC</label>
            </div>
            <div class="col-sm-9">
                <el-input type="text" v-validate="'required'" required name="nombre" placeholder="Numero de OC" v-model="totalBuyOrders"></el-input>
                <!-- <span>{{ errors.first('nombre') }}</span> -->
            </div>
          </div>
          <div class="col-sm-12 entrada">
              <div class="col-sm-3">
                  <label>OC (PDF)</label>
              </div>
              <div class="col-sm-9">
                <input type="file" accept="application/pdf" ref="fileBuyOrder" class="form-control-file" style="width:80%; float: left;">
                <el-button type="primary" style="margin-left:6%;" circle icon="el-icon-upload">
                </el-button>
              </div>
          </div>
        <span slot="footer" class="dialog-footer">
            <button class="btn btn-primary" v-on:click="saveNIC()">
              Guardar
            </button>
            <button class="btn" v-on:click="showModal = false">
              Cancelar
            </button>
        </span>
    </el-dialog>
     <h3> Panel de control </h3>
      <div class="row" v-if="statusList">
        <div class="col-md-12 col-lg-12">
          <div class="box box-info">
            <div class="box-body">
              <table class="table table-striped">
                <thead>
                  <tr style="'font-size: 15px; text-align:center;">
                    <th :style="'text-align: center; vertical-align: middle;width: ' + (100 / statusList.length) + '%'" v-for="item in statusList" :key="item.statusId">asd{{item.description}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style="font-size: 25px; text-align:center" v-loading="loadingStatus">
                    <td  class="statusHover" v-for="item in statusList" :key="item.statusId" v-on:click="searchStatus(item.statusId)">{{statusCount[item.statusId]}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 text-center" v-if="response" >
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
              <div class="info-box ">
                <span class="info-box-icon bg-yellow"><i class="ion ion-android-alert"></i></span>
                <div class="info-box-content">
                  <span class="info-box-text">Advertencia</span>
                  <span class="info-box-info">{{response}}</span>
                </div>
                <!-- /.info-box-content -->
              </div>
            <!-- /.info-box -->
          </div>
        </div>
      </div>

      <el-button v-if="$route.path === '/buyOrders'" v-on:click="showModal = true">Nuevo...</el-button>
      <div class="box-body">
        <h3> Filtros </h3>
        <div style="margin-bottom: 10px">
          <el-row>
            <el-col :xs="24" :sm="2" :md="1" style="margin-top: 8px" class="filter">
              <span class="input-label"> OC </span>
            </el-col>
            <el-col :xs="24" :sm="8" :md="6">
              <el-input type="text" placeholder="OC" clearable v-model="nicFilter" @keyup.enter.native="filters[2].value = nicFilter" @blur="filters[2].value = nicFilter" @clear="filters[2].value = nicFilter">
              </el-input>
            </el-col>
            <el-col :xs="24" :sm="2" :md="1" class="filter" style="margin-top:5px">
              <span class="input-label"> Estado </span>
            </el-col>
            <el-col :xs="24" :sm="8" :md="4">
              <el-select clearable placeholder="Estado" multiple v-model="filters[0].value" style="width:100%">
                <el-option
                  v-for="item in statusList"
                  :key="item.statusId"
                  :value="item.statusId"
                  :label="item.description">
                </el-option>
              </el-select>
            </el-col>
            <el-col :xs="24" :sm="2" :md="1" class="filter" style="margin-top:8px">
              <span class="input-label"> Fecha </span>
            </el-col>
            <el-col :xs="24" :sm="19" :md="6">
              <el-date-picker
              style="width:100%"
              v-model="filters[1].value"
              type="daterange"
              range-separator="A"
              start-placeholder="Desde"
              end-placeholder="Hasta"
              value-format="yyyy-MM-dd"
              unlink-panels>
              </el-date-picker>
            </el-col>
          </el-row>
        </div>

        <h3> Resultados </h3>
        <data-tables-server v-loading="loadingBuyOrders" :data="buyOrders" class="table-responsive" @query-change="getBuyOrders" :total="totalBuyOrders" :pagination-props="{ pageSizes: [10, 20, 30] }"  :filters="filters">

          <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :sortable="title.sortable">
          </el-table-column>
          <el-table-column v-if="$route.path !== '/toBill'" prop="fecha_liberacion" label="Liberación" sortable="custom">
          </el-table-column>
          <el-table-column v-else sortable="custom" prop="documentDate" label="Documentación enviada">
          </el-table-column>
          <el-table-column label="Estado" :align="'center'">
            <template slot-scope="scope">
              {{ getStatusName(scope.row.statusId) }}
            </template>
          </el-table-column>
          <el-table-column :align="'center'" v-if="user.isProvider" :label="'Aceptado'" width="100px">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" v-if="scope.row.view === '0' && (scope.row.statusId === '2' || scope.row.statusId === '3')" content="Recibido" placement="right">
                <i class="el-icon-message"></i>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" v-else content="Aceptado" placement="right">
                <i class="el-icon-view"></i>
              </el-tooltip>
            </template>
          </el-table-column>
          <!--

          <el-table-column :align="'center'" v-if="false && user.isProvider" :label="'Factura'" width="100px">
            <template slot-scope="scope">
              <span v-if="scope.row.mensajeFacturaRechazada === null">
                <el-tooltip class="item" effect="dark" v-if="scope.row.statusId === '4'" content="Enviada" placement="right">
                  <i class="el-icon-upload2"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" v-if="scope.row.statusId === '5'" content="Aceptada" placement="right">
                  <i class="el-icon-check"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" v-if="scope.row.statusId <= '3'" content="Sin subir" placement="right">
                  <i class="el-icon-minus"></i>
                </el-tooltip>
              </span>
              <span v-else>
                <el-tooltip class="item" effect="dark" content="Rechazada" placement="right">
                  <i class="el-icon-close"></i>
                </el-tooltip>
              </span>
            </template>
          </el-table-column>

          <el-table-column :align="'center'" v-if="false && user.isProvider" :label="'G. Pago'" width="100px">
            <template slot-scope="scope">
              <span v-if="scope.row.payment">
                <el-tooltip class="item" effect="dark" v-if="scope.row.payment.visto === '0'" content="Recibido" placement="right">
                  <i class="el-icon-message"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" v-else content="Visto" placement="right">
                  <i class="el-icon-view"></i>
                </el-tooltip>
              </span>
              <span v-else>
                <el-tooltip class="item" effect="dark" content="No posee" placement="right">
                  <i class="el-icon-minus"></i>
                </el-tooltip>
              </span>
            </template>
          </el-table-column>
          -->

          <el-table-column :align="'center'" v-if="!user.isProvider" :label="'Tarea'" width="100px">
            <template slot-scope="scope">
              <span v-if="scope.row.documents">
                <el-tooltip class="item" effect="dark" v-if="scope.row.view === '0' && (scope.row.statusId === '4')" content="Recibido" placement="right">
                  <i class="el-icon-message"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" v-else content="Aceptado" placement="right">
                  <i class="el-icon-view"></i>
                </el-tooltip>
              </span>
              <span v-else>
                <el-tooltip class="item" effect="dark" content="No posee" placement="right">
                  <i class="el-icon-minus"></i>
                </el-tooltip>
              </span>
            </template>
          </el-table-column>

          <el-table-column label="" :align="'center'">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="Detalles" placement="top">
                  <el-button type="primary" icon="el-icon-view" circle @click="goToDetails(scope.row.idBuyOrder)"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>

        </data-tables-server>
      </div>
    </section>
  </div>
</template>
<script>
  require('moment')
  // Require needed datatables modules
  import datepicker from 'vue-date-picker'
  import api from '../../api'
  import MaskedInput from 'vue-text-mask'
  import apiHelper from '../helpers/apiHelper'
import { mapState } from 'vuex'

  export default {
    name: 'Search',
    components: {
      datepicker,
      MaskedInput
    },
    data (router) {
      return {
        statusCount: [],
        totalBuyOrders: 0,
        nicFilter: '',
        buyOrders: [],
        loadingBuyOrders: false,
        loadingStatus: false,
        currentApiCalls: 0,
        currentApiStatusCalls: 0,
        dummyFilter: '',
        section: 'Search',
        loading: '',
        tipoFecha: 'emision',
        estado: '',
        response: '',
        desde: '',
        hasta: '',
        showModal: false,
        cliente: '',
        referencia: '',
        fecha: '',
        facturas: this.$store.state.facturas,
        providers: null,
        clients: [],
        receptor: '',
        idUser: this.$store.state.user.idUser,
        filtrados: [],
        table: '',
        vue: this,
        rutMask: this.$store.state.rutMask,
        invoiceMask: this.$store.state.invoiceMask,
        titles: [{                      // Columnas que se van a mostrar
          prop: 'nic',
          label: 'OC',
          sortable: 'custom'
        },
        {                      // Columnas que se van a mostrar
          prop: 'company',
          label: 'Proveedor'
        }],
        filters: [{
          prop: 'statusId',
          value: '',
          type: 'multiSelect'
        },
        {
          prop: 'fecha_liberacion',
          type: 'dateRange',
          value: ''
        },
        {
          prop: 'nic',
          value: ''
        }]
      }
    },
    computed: {
      ...mapState([
        'user'
      ]),
      statusList () {
        let status = this.$store.state.countStatus.filter(el => this.statusByPath().includes(el.statusId))
        return status
      }
    },
    beforeRouteUpdate (to, from, next) {
      if (to === from) {
        this.filters[0].value = from.params.statusId
      }
      next()
    },
    saveNIC () {
      if (this.companyNew.nombre !== '' && this.companyNew.razonSocial !== '' /* && this.companyNew.corporateMail */ && this.companyNew.cuit !== '' && this.currentIdRubro !== undefined && this.currentIdRubro.length > 0) {
        api.request('POST', 'api/generic/company', JSON.stringify({ 'company': this.companyNew.nombre, 'companyName': this.companyNew.razonSocial, 'idCompanyStatus': 2, 'cuit': this.companyNew.cuit /*, 'corporateMail': this.companyNew.corporateMail */, 'reasonCalification': this.companyNew.descripcion, 'idCompany': '' }))
            .then(response => {
              this.currentIdRubro.forEach((item, index) => {
                api.request('POST', 'api/generic/rubrosCompany/', JSON.stringify({'idRubro': this.currentIdRubro[index], 'idCompany': response.data.idCompany}))
                .then(response => {
                  this.$message.success('Se ha agregado la nueva empresa', 'success')
                  this.hideModal()
                  this.$parent.getProviders()
                })
              })
            })
            .catch(error => {
              this.$message.error(error.response.data, 'error')
            })
      } else {
        this.$message.warning('Debe completar todos los campos', 'warning')
      }
    },
    mounted () {
      if (this.$route.params.statusId) {
        this.filters[0].value = this.$route.params.statusId
      }
    },
    methods: {
      statusByPath () {
        switch (this.$route.path) {
          case '/buyOrders':
            return ['1', '2', '7']
          case '/toBill':
            return ['3', '9']
          default:
            return ['1', '2', '3', '7', '9']
        }
      },
      startLoadingStatus () {
        this.currentApiStatusCalls++
        this.loadingStatus = true
      },
      stopLoadingStatus () {
        this.currentApiStatusCalls--
        if (this.currentApiStatusCalls === 0) this.loadingStatus = false
      },
      startLoading () {
        this.currentApiCalls++
        this.loadingBuyOrders = true
      },
      stopLoading () {
        this.currentApiCalls--
        if (this.currentApiCalls === 0) this.loadingBuyOrders = false
      },
      getCondition () {
        let condition = '('
        let pathStatus = this.statusByPath()
        for (let index = 0; index < pathStatus.length;) {
          condition += 'statusId = ' + pathStatus[index]
          index++
          if (index < pathStatus.length) {
            condition += ' OR '
          }
        }
        condition += ')'
        return condition
      },
      getTotalBuyOrder (queryInfo = '') {
        let substringPosition = queryInfo.search('condition=')
        let query = queryInfo.substring(substringPosition + 10)
        let condition = this.getCondition()
        if (this.user.isProvider) {
          apiHelper.getTotal('buyOrder', query + ' AND ' + condition + ' AND idCompany =' + this.user.company.idCompany)
          .then(count => {
            this.totalBuyOrders = count
          })
        } else {
          apiHelper.getTotal('buyOrder', query + ' AND ' + condition)
          .then(count => {
            this.totalBuyOrders = count
          })
        }
      },
      getBuyOrders (queryInfo = '') {
        let condition = this.getCondition()
        let query = apiHelper.getQueryForApi(queryInfo)
        this.startLoading()
        api.request('GET', 'api/getBuyOrder/' + this.user.idUser + query + ' AND ' + condition)
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            let orders = data
            this.buyOrders = orders
          }
          this.stopLoading()
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
          this.loadingBuyOrders = false
        })
        this.getTotalBuyOrder(query)
      },
      searchStatus (status) {
        this.filters[0].value = [status]
        // this.filterInvoices()
      },
      getStatusName (statusId) {
        if (this.statusList.length > 0) {
          return this.statusList.find(el => el.statusId === statusId).description
        } else {
          return '-'
        }
      },
      getCountByStatus () {
        //  return this.buyOrders.filter(el => el.statusId === statusId).length
        this.statusByPath().forEach(item => {
          this.startLoadingStatus()
          if (this.user.isProvider) {
            apiHelper.getTotal('buyOrder', 'statusId = ' + item + ' AND idCompany =' + this.user.company.idCompany)
            .then(count => {
              this.statusCount[item] = count
              this.stopLoadingStatus()
            })
          } else {
            apiHelper.getTotal('buyOrder', 'statusId = ' + item)
            .then(count => {
              this.statusCount[item] = count
              this.stopLoadingStatus()
            })
          }
        })
      },
      goToDetails (idBuyOrder) {
        this.$router.push('/invoicedetail?i=' + idBuyOrder)
      },
      toggleLoading () {
        this.loading = (this.loading === '') ? 'cargando' : ''
      },
      resetResponse () {
        this.response = ''
      },
      compareViewNics (a, b) {
        if (a.view < b.view) {
          return -1
        } else if (a.view > b.view) {
          return 1
        }
        /* else if (a.payment && b.payment && a.payment.visto < b.payment.visto) {
          return -1
        } else if (a.payment && b.payment && a.payment.visto > b.payment.visto) {
          return 1
        } */
        return 0
      },
      compareViewInvoice (a, b) {
        if (!a.factura) {
          return 1
        }
        if (!b.factura) {
          return -1
        }
        if (a.factura.visto < b.factura.visto) {
          return -1
        } else if (a.factura.visto > b.factura.visto) {
          return 1
        }
        return 0
      }
    },
    beforeMount () {
      this.getCountByStatus()
    }
  }
</script>
<style>
  @media (min-width: 767px) {
    .filter {
      text-align: center;
    }
  }
  .datetime-picker input {
    height: 4em !important;
  }

  /* Using the bootstrap style, but overriding the font to not draw in
   the Glyphicons Halflings font as an additional requirement for sorting icons.

   An alternative to the solution active below is to use the jquery style
   which uses images, but the color on the images does not match adminlte. */

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
}
table.dataTable tr {
  cursor: pointer
}
.table {
  width: 100% !important;
}
.dataTables_length label, .dataTables_filter label{
  margin-bottom: 30px;
  position:static;
  display:block;
  pointer-events: fill;
  z-index:3000;
}
.statusHover:hover {
  transition: background-color 0.5s ease;
  cursor: pointer;
  background-color:darkgray;
  color:black;
}

.filtro {
  margin-bottom: 10px;
}
.sorting::after, .sorting_asc:after, .sorting_desc:after {
  margin-left: 5px;
}

.input-label {
    display: inline-block;
    padding: 2px 10px;
    margin-bottom: 12px;
  }
</style>



// WEBPACK FOOTER //
// Search.vue?5e7f06cc